module.exports = __webpack_public_path__ + "static/media/green-in-german.10d93b3d.jpg";